import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
	selector: '[inputRestriction]',
	standalone: true
})
export class InputRestrictionDirective {
	@Input() inputRestriction: 'date' | 'numeric' | 'alpha' | 'alphanumeric' | 'decimal' | 'decimalExtended';
	@Input('inputRestrictionDecimals') decimals = 4;
	@Input('inputRestrictionAllowNegative') allowNegative = false;

	inputElement: ElementRef;

	numericRegex = new RegExp(`^[0-9]*$`, 'i');
	numericNegativeRegex = new RegExp(`^[-]?[0-9]*$`, 'i');
	alphaRegex = new RegExp(`^[a-zA-Z]*$`, 'i');
	alphanumericRegex = new RegExp(`^[a-zA-Z0-9]*$`, 'i');
	decimalRegex = new RegExp(`^-?[0-9]{0,15}([\\.,][0-9]{0,2})?$`, 'i');
	decimalExtendedRegex: RegExp;

	// The date regexp tests if the input value is matachable with a date format
	// ex: "99" OR "99/"" OR "99/99" OR "99/99/"" OR "99/99/9999"
	// eslint-disable-next-line no-useless-escape
	dateRegex = new RegExp(`^([0-9]{1,2}\/?)$|^([0-9]{1,2}\/[0-9]{1,2}\/?)$|^([0-9]{1,2}\/[0-9]{1,2}\/[0-9]{0,4})$`, 'i');


	constructor(el: ElementRef) {
		this.inputElement = el;
	}


	@HostListener('keypress', ['$event']) onKeyPress(e: KeyboardEvent): void {
		const key = e.key;
		const currentValue: string = this.inputElement.nativeElement.value;
		let start = this.inputElement.nativeElement.selectionStart;
		let end = this.inputElement.nativeElement.selectionEnd;

		if (start === null && end === null) {
			start = end = currentValue.length;
		}

		const targetValue: string = [currentValue.slice(0, start), key, currentValue.slice(end)].join('');

		switch (this.inputRestriction) {
		case 'numeric':
			if (!this.isNumber(targetValue)) {
				e.preventDefault();
			}
			break;

		case 'alpha':
			if (!this.isAlpha(targetValue)) {
				e.preventDefault();
			}
			break;

		case 'alphanumeric':
			if (!this.isAlphanumeric(targetValue)) {
				e.preventDefault();
			}
			break;

		case 'date':
			if (!this.isDate(targetValue)) {
				e.preventDefault();
			}
			break;

		case 'decimal':
			if (!this.isDecimal(targetValue)) {
				e.preventDefault();
			}
			break;

		case 'decimalExtended':
			if (!this.isDecimalExtended(targetValue)) {
				e.preventDefault();
			}
			break;
		}
	}

	isNumber(value: string): boolean {
		return this.allowNegative ? this.numericNegativeRegex.test(value) : this.numericRegex.test(value);
	}

	isAlpha(value: string): boolean {
		return this.alphaRegex.test(value);
	}

	isAlphanumeric(value: string): boolean {
		return this.alphanumericRegex.test(value);
	}

	isDate(value: string): boolean {
		return this.dateRegex.test(value);
	}

	isDecimal(value: string): boolean {
		return this.decimalRegex.test(value) && (+value.replace(',', '.') >= 0 || this.allowNegative);
	}

	isDecimalExtended(value: string): boolean {
		this.decimalExtendedRegex = new RegExp(`^-?[0-9]{0,15}([\\.,][0-9]{0,${this.decimals}})?$`, 'i');
		return this.decimalExtendedRegex.test(value) && (!this.allowNegative || parseFloat(value.replace(/,/, '.')) >= 0);
	}
}
